/**
 * Generate a stable internalId for a waypoint that matches what the backend
 * expects when creating or updating temporary (draft) waypoints.
 *
 * This keeps the id identical across saves (e.g. card edits and drag-and-drop
 * reorders) so the backend updates the same draft instead of creating new ones.
 */
export const getStableInternalId = (waypoint: {
    id?: string;
    internalId?: string;
    waypointId?: string | null;
}): string => {
    if (waypoint.internalId) {
        return waypoint.internalId;
    }
    const waypointId = waypoint.waypointId || waypoint.id;
    return `${waypointId}-temp-iduniqueen`;
};
